import * as React from "react";
import List from './mui/List';
import ListItem from './mui/ListItem';
import ListItemText, { ListItemTextProps } from './mui/ListItemText';
import ListItemIcon from './mui/ListItemIcon';
import Collapse from './mui/Collapse';
import ExpandLess from "./icons/ExpandLess";
import ExpandMore from "./icons/ExpandMore";
import { WithStyles, withStyles, createStyles, Theme } from './mui/styles';
import { StyleRulesCallback } from "@material-ui/core";

const styles = (({ spacing }: Theme) => createStyles({
    gutters: {},
    nested: {
        paddingLeft: 3 * spacing.unit,
    },
    icon: {
        marginRight: 0
    }
})) as StyleRulesCallback;

interface Props extends WithStyles<typeof styles> {
    button?: boolean;
    icon?: any;
    children?: React.ReactNode;
}

interface State {
    open: boolean;
}

export type ExpandableListItemProps = Props & ListItemTextProps;

export default withStyles(styles)(
    class extends React.Component<ExpandableListItemProps, State>{

        constructor(props: ExpandableListItemProps) {
            super(props);
            this.state = {
                open: false
            }
        }

        private handleClick = () => {
            this.setState(state => ({ open: !state.open }));
        };

        private renderChildren() {
            return React.Children.map(this.props.children, (child: React.ReactElement<any>) => {
                return React.cloneElement(child, {
                    className: this.props.classes.nested
                })
            })
        }

        render() {
            const { icon, primary, secondary, button, inset, classes } = this.props;
            return <React.Fragment>
                <ListItem button={button} onClick={this.handleClick} classes={{ gutters: classes.gutters }}>
                    {inset && icon && <ListItemIcon classes={{ root: classes.icon }}>{icon}</ListItemIcon>}
                    <ListItemText inset={inset} primary={primary} secondary={secondary} />
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <List disablePadding >
                        {this.renderChildren()}
                    </List>
                </Collapse>
            </React.Fragment>
        }
    });